import React,{useEffect,useState} from 'react' 
import {useParams,Link } from 'react-router-dom';
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Footer from '../footer/Footer';
import axios from "../helper/axios";
import {useSelector,useDispatch} from "react-redux";
import "../product.css";

export default function ProductView() {
  let { type,id,productId } = useParams();
	const auth = useSelector(state=>state.auth);
  const [product,setProduct] = useState([]);
  const apiData=async()=>{
    const data={email:auth?.user?.email,
                role:auth?.user?.role,
                productId:productId}
    const res=await axios.post("/productdetail",data)
    if(res.status===200){
      setProduct(res.data);
    }
  }

  useEffect(()=>{
    apiData();
  },[])

console.log(product);
	return (
		<div>
		<div className="sidebar-mini skin-green-light">
		<div className="wrapper"> 
  		  <Header/> 
  		  {auth?.user?.role==="Vendor"?<VendorSidebar/>:<Sidebarr/>}
  <div className="content-wrapper"> 
        <section className="content-header">
          <h1>
            Product Details
          </h1>
          <ol className="breadcrumb">
            <li><Link to="/"><i className="fa fa-dashboard" /> Home</Link></li> 
            <li className="active">User profile</li>
          </ol>
        </section> 
        <section className="content">
          <div className="row">
            <div className="col-md-3"> 
              <div className="box box-primary">
                <div className="box-body box-profile"> 
                <img src={product[0]?.images[0]}
                height="320"
                width="100%"
                />
                </div> 
              </div> 
             {/* <div className="box box-primary">
                <div className="">
                  <h3 className="box-title ">
                  <div className="row">
                    <ul className="col-sm-8 imgFlex">
                    {product[0]?.stocks?.pic.map((dt)=>(
                      <li><img src={dt} height="40" width="40"/></li>
                      ))} 
                    </ul>
                    </div>
                  </h3>
                </div> 
                 
              </div> */}



            </div> 
            <div className="col-md-9">
             {product?.map(dt=>(
              <div className="nav-tabs-custom">

                <ul className="nav nav-tabs"> 
                  <li className="active"><a href="#settings" data-toggle="tab">Details</a></li>
                </ul>
               
                <div className="tab-content">
                  <div className="active tab-pane" id="settings">
                    <form className="form-horizontal ">
                      <div className="form-group txtLeft">
                        <label htmlFor="inputName" className="col-sm-4 control-label">Product Name</label>
                        <p className="col-sm-8 control-label">{dt?.description}</p> 
                      </div>  
                      <div className="form-group txtLeft">
                        <label htmlFor="inputName" className="col-sm-4 control-label">Items Code</label>
                        <p className="col-sm-8 control-label">{dt?.stocks?.itemCode}</p> 
                      </div>  
                      <div className="form-group txtLeft">
                        <label htmlFor="inputName" className="col-sm-4 control-label">Items No</label>
                        <p className="col-sm-8 control-label">{dt?.stocks?.itemNo}</p> 
                      </div>  
                      <div className="form-group txtLeft">
                        <label htmlFor="inputName" className="col-sm-4 control-label">Stock Qty</label>
                        <p className="col-sm-8 control-label">{dt?.stocks?.stockQty}</p> 
                      </div>   
                      <div className="form-group txtLeft">
                        <label htmlFor="inputName" className="col-sm-4 control-label">Stock Status</label>
                        {dt?.stocks?.stockQty>0?<p className="col-sm-8 control-label" style={{backgroundColor:"green",color:"white", padding:"1px 3px", width:"100px",textAlign:"center"}}>In Stock</p>:<p className="col-sm-8 control-label" style={{backgroundColor:"red",color:"white", padding:"1px 3px", width:"100px",textAlign:"center"}}>Out of Stock</p>}
                      </div>  
                      <div className="form-group txtLeft">
                        <label htmlFor="inputName" className="col-sm-4 control-label">Sizes</label>
                        <p className="col-sm-8 control-label">{dt?.stocks?.size}</p> 
                      </div>  

                    </form>
                  </div> 
                </div> 



              </div> 
              ))}
            </div> 
          </div> 
        </section> 
      </div>  
<Footer/> 
   
  <div className="control-sidebar-bg" />
</div>

      
    </div>
		</div>
	)
}